/*
 * DATA_RIGHTS: HONEYWELL CONFIDENTIAL AND PROPRIETARY
 * THIS WORK CONTAINS VALUABLE CONFIDENTIAL AND PROPRIETARY
 * INFORMATION. DISCLOSURE, USE OR REPRODUCTION OUTSIDE OF
 * HONEYWELL INTERNATIONAL, INC. IS PROHIBITED EXCEPT AS
 * AUTHORIZED IN WRITING. THIS UNPUBLISHED WORK IS PROTECTED BY
 * THE LAWS OF THE UNITED STATES AND OTHER COUNTRIES. IN THE
 * EVENT OF PUBLICATION, THE FOLLOWING NOTICE SHALL APPLY:
 * Copyright (C) 2022 HONEYWELL INTERNATIONAL, INC., ALL RIGHTS RESERVED.
 *
 * Created by H144765 on 2/15/2022.
 */

import React from 'react'
import {injectIntl, FormattedHTMLMessage} from 'react-intl';
import {formatDateTime} from "../../common/LocaleHelper";
import {LOG_ACTION_TYPES} from "./FaultsConst";
import {sliceItemsFromEnd} from "../../utils/Helpers";
import {Button, Table} from "@scuf/common";

class ActionLogTable extends React.Component {
    constructor(props) {
        super(props)

        this.state = {
            expanded: this.props.expanded || false,
        }
    }

    getLogRow(log) {
        const {intl} = this.props
        let changeText = '';
        let valueText
        switch (log.objectType) {
            case 'CONFIGURATION_SYMPTOM':
            case 'FAILURE_MODE':
                changeText = <FormattedHTMLMessage id={'action.log.' + log.objectType + '.' + log.actionType}
                                                   values={{name: log.objectName, value: log.valueId}}/>
                break;
            case 'CORRECTIVE_ACTION':
                valueText = intl.formatMessage({id: "fault.troubleshoot.ca.state." + log.valueId})
                changeText = <FormattedHTMLMessage id={'action.log.' + log.objectType + '.' + log.actionType}
                                                   values={{name: log.objectName, value: valueText}}/>
                break
            case 'TEST':
            case 'TEST_LEARNING_LOOP':
                valueText = log.valueName ? log.valueName : intl.formatMessage({id: "fault.troubleshoot.test.result.not_performed"})
                changeText = <FormattedHTMLMessage id={'action.log.' + log.objectType + '.' + log.actionType}
                                                   values={{name: log.objectName, value: valueText}}/>
                break;
            case 'SYMPTOM':
                changeText = <FormattedHTMLMessage id={'action.log.' + log.objectType + '.' + log.actionType} values={{
                    name: log.objectName,
                    value: log.valueName,
                    criticality: log.criticality * 100,
                }}/>
                break;
            case 'FAULT_CONDITION':
                if (log.actionType === LOG_ACTION_TYPES.LL_PACKET_SENT || log.actionType === LOG_ACTION_TYPES.ASSIGNEE_SET) {
                    if (log.actionType === LOG_ACTION_TYPES.ASSIGNEE_SET && log.valueId == null) {
                        changeText = <FormattedHTMLMessage
                            id={'action.log.' + log.objectType + '.' + log.actionType + ('.UNASSIGNED')}/>
                    } else {
                        changeText = <FormattedHTMLMessage
                            id={'action.log.' + log.objectType + '.' + log.actionType}
                            values={{name: log.objectName, value: log.valueName}}/>
                    }
                } else {
                    changeText = <FormattedHTMLMessage
                        id={'action.log.' + log.objectType + '.' + log.actionType + (log.valueId ? '.' + log.valueId : '')}
                        values={{name: log.objectName, value: log.valueName}}/>
                }
                break;
            // Possible logs cause by LDI import
            case 'TEST_VARIANT':
            case 'CORRECTIVE_ACTION_VARIANT':
            case 'FAILURE_MODE_VARIANT':
            case 'SYMPTOM_VARIANT':
            case 'TEST_RESULT':
            case 'CORRECTIVE_ACTION_SYMPTOM':
                changeText = <FormattedHTMLMessage
                    id={'action.log.' + log.objectType + '.' + log.actionType}
                    values={{name: log.objectName, valueName: log.valueName}}
                />
                break;
            // Possible logs cause by LDI import
            case 'FAILURE_MODE_CORRECTIVE_ACTION':
            case 'SYMPTOM_OCCURRENCE':
                changeText = <FormattedHTMLMessage
                    id={'action.log.' + log.objectType + '.' + log.actionType}
                    values={{name1: log.objectName, name2: log.valueName}}
                />
                break;
            case 'VARIANT':
            case 'SYMPTOM_GROUP':
            case 'CA_OBSOLETE_RELATION':
            case 'FM_OBSOLETE_RELATION':
            case 'S_OBSOLETE_RELATION':
            case 'T_OBSOLETE_RELATION':
            case 'TR_OBSOLETE_RELATION':
            case 'V_OBSOLETE_RELATION':
                changeText = <FormattedHTMLMessage
                    id={'action.log.' + log.objectType + '.' + log.actionType}
                    values={{name: log.objectName}}
                />
                break;
            default:
                break;
        }

        return (
            <Table.Row>
                <Table.Cell>
                    {log.userName}
                </Table.Cell>
                <Table.Cell>
                    {formatDateTime(log.createDate)}
                </Table.Cell>
                <Table.Cell>
                    {changeText}
                </Table.Cell>
            </Table.Row>
        )
    }

    render() {
        const {actionLog, intl} = this.props

        const logComponents = actionLog.map(l => this.getLogRow(l))
        let emptyMessage = '';
        if (logComponents.length === 0) {
            emptyMessage = intl.formatMessage({id: "action.log.noAction"})
        }
        const slicedLogItems = sliceItemsFromEnd(logComponents, this.props.initDisplayCount);

        let expandLink = null
        if (slicedLogItems[1].length > 0 && !this.state.expanded) {
            expandLink = <div className="expand-link">
                <Button type="link"
                        onClick={() => this.setState({expanded: !this.state.expanded})}>
                    {intl.formatMessage({id: "action.log.more"}, {count: slicedLogItems[1].length})}
                </Button>
            </div>
        }

        return (
            <div className="ui history-table">
                <Table>
                    <Table.Header>
                        <Table.HeaderCell content="user" />
                        <Table.HeaderCell content="date" />
                        <Table.HeaderCell content="action" />
                    </Table.Header>
                    <Table.Body>
                        {this.state.expanded &&
                            slicedLogItems[1]
                        }
                        {!this.state.expanded && slicedLogItems[1].length > 0 &&
                            <Table.Row>
                                <Table.Cell colSpan={4}>
                                    <div className={"expandable-list"}>
                                        {expandLink}
                                    </div>
                                </Table.Cell>

                            </Table.Row>
                        }
                        {slicedLogItems[0]}
                    </Table.Body>
                </Table>
                {emptyMessage}
            </div>
        )
    }
}

ActionLogTable.defaultProps = {
    initDisplayCount: 3,
    displayFaultName: false,
    displayAssetName: false,
}

export default injectIntl(ActionLogTable)